import { log } from '../logger'

type Data = Record<string, unknown>
enum LogType {
  info,
  warn,
  error,
}

export type NewRelicType = {
  data: Data
  message: string
}

export type LogPayloadType = NewRelicType & {
  logType: LogType
}

export const newRelicLogger = {
  info: async (data: Data, message: string) => {
    await sendLogToNewRelic({ data, message, logType: LogType.info })
  },

  warn: async (data: Data, message: string) => {
    await sendLogToNewRelic({ data, message, logType: LogType.warn })
  },

  error: async (data: Data, message: string) => {
    await sendLogToNewRelic({ data, message, logType: LogType.error })
  },
}

const sendLogToNewRelic = async (payload: LogPayloadType) => {
  const bodyJson = JSON.stringify(payload)
  try {
    await fetch('/api/logger/newrelic', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: bodyJson,
    })
  } catch {
    //Logging in browser when api failing
    mapLog(payload, null)
  }
}

export const mapLog = (payload: LogPayloadType, context: any) => {
  const data = payload?.data
  const isBrowser = true

  if (payload?.logType === LogType.info) {
    log.info({ data, context, isBrowser }, `BROWSER_LOG: ${payload.message}`)
  } else if (payload?.logType === LogType.warn) {
    log.warn({ data, context, isBrowser }, `BROWSER_LOG: ${payload.message}`)
  } else if (payload?.logType === LogType.error) {
    log.error({ data, context, isBrowser }, `BROWSER_LOG: ${payload.message}`)
  }
}
